import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Trans, useTranslation } from 'react-i18next'
import { useLocale } from '@/i18n/useLocale'
import { localePath, ROUTES } from '@/lib/routes'
import { useConsent } from './consentContext'

export function ConsentBanner() {
  const { choice, setChoice } = useConsent()
  const { t } = useTranslation()
  const locale = useLocale()
  const [analytics, setAnalytics] = useState(false)

  if (choice) return null

  return (
    <div
      role="dialog"
      aria-labelledby="consent-title"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md
        rounded-lg bg-mono-100 dark:bg-mono-900 text-mono-800 dark:text-mono-100
        shadow-emboss dark:shadow-emboss-dark p-5 z-50"
    >
      <h2 id="consent-title" className="text-base font-semibold mb-2">
        {t('consent.title')}
      </h2>
      <p className="text-base leading-relaxed mb-4 opacity-80">
        <Trans
          i18nKey="consent.summaryLong"
          components={{
            policy: (
              <Link
                to={localePath(locale, ROUTES.privacy)}
                className="underline underline-offset-2 hover:opacity-100"
              />
            ),
          }}
        />
      </p>

      {/* Necessary — always-on disclosure */}
      <div className="flex items-center justify-between gap-3 text-base mb-2">
        <span className="flex flex-col">
          <span className="font-medium">{t('consent.necessary')}</span>
          <span className="text-[10px] opacity-60 mt-0.5">{t('consent.necessaryBlurb')}</span>
        </span>
        <span className="text-[10px] font-semibold uppercase opacity-50">Always on</span>
      </div>

      {/* Analytics toggle */}
      <label className="flex items-center justify-between gap-3 text-base mb-4">
        <span>{t('consent.category.analytics')}</span>
        <input
          type="checkbox"
          checked={analytics}
          onChange={(e) => setAnalytics(e.target.checked)}
          className="h-4 w-4"
        />
      </label>

      <div className="flex flex-col sm:flex-row gap-2">
        <button
          className="flex-1 py-2 rounded-md text-base font-medium bg-mono-800 dark:bg-mono-100 text-mono-100 dark:text-mono-900"
          onClick={() => setChoice({ analytics: true })}
        >
          {t('consent.accept')}
        </button>
        <button
          className="flex-1 py-2 pr-2 rounded-md text-base font-medium marker-dot"
          onClick={() => setChoice({ analytics: false })}
        >
          {t('consent.reject')}
        </button>
        <button
          className="flex-1 py-2 rounded-md text-base font-medium underline-offset-4 underline opacity-80"
          onClick={() => setChoice({ analytics })}
        >
          {t('consent.save')}
        </button>
      </div>
    </div>
  )
}
